/* ===== WELLBI · DIWALI EASTER EGG: "Light the Diyas" =====
   A faint unlit diya hides at the end of the "Ridiculously comfortable." line
   (falls back to the footer). Tap it to play: light 10 floating diyas in 10s
   to win a free gift.
   - The win is stored (signed, tamper-evident) in localStorage for 2 hours.
   - Gift needs cart >= MIN_CART (excluding gift). If the cart reaches it within
     the 2 hours, the gift is added automatically. Otherwise the win expires.
   - If the cart drops below MIN_CART the gift is removed instantly (and re-added
     if the cart goes back above it while the win is still valid).
   - Cart changes inside the Shopflo iframe are caught by fast polling + postMessage.
   Include: <script src="diya-game.js" defer></script>
   Test: add ?diya=1 to any URL to open the game straight away. */
(function () {
  if (window.__wellbiDiya) return;
  window.__wellbiDiya = true;

  /* ---- edit the rewards here ----
     One of these is picked at random when the gift is granted.
     These must be VARIANT ids (what /cart/add.js expects). */
  var REWARD_IDS = [
    45275228242128,
    45275228209360,
    45274936115408
  ];
  var MIN_CART = 999;                        /* rupees, cart value WITHOUT the gift */
  var GOAL = 10, TIME = 10;
  var POLL_MS = 400;                         /* watcher speed while gift/win is active */

  /* ---- stored win ---- */
  var WIN_TTL = 2 * 60 * 60 * 1000;          /* 2 hours */
  var WIN_KEY = 'wellbi_diya_win';
  var SALT = 'wlb-7Kq9xV2mZp4Rt8Ud-Lm3Ya6Hs'; /* keep the same across deploys */

  /* phones are easier to tap, so they get a tougher round */
  var TOUCH = window.matchMedia && matchMedia('(pointer: coarse), (max-width: 600px)').matches;
var BOMB_BASE = .24;   /* base cracker chance. was .14 */
var SPD = TOUCH ? 1.7 : 1, SWAY = TOUCH ? 2 : 1, BOMB = TOUCH ? .10 : 0;
  var CSS = `
.dy-egg{display:inline-flex;vertical-align:middle;margin-left:.25em;width:.62em;height:.62em;min-width:26px;min-height:26px;border:none;background:none;padding:0;cursor:pointer;opacity:.38;transition:opacity .3s,transform .3s}
.dy-egg:hover,.dy-egg:focus-visible{opacity:1;transform:translateY(-2px) rotate(-6deg)}
.dy-egg svg{width:100%;height:100%;display:block}
.dy-egg .fl{opacity:0;transform-origin:50% 100%;transition:opacity .3s}
.dy-egg:hover .fl{opacity:1;animation:dyFl .16s ease-in-out infinite alternate}
@keyframes dyFl{from{transform:scaleY(1) rotate(-4deg)}to{transform:scaleY(1.15) rotate(4deg)}}

.dy-m{position:fixed;inset:0;z-index:2147483100;display:none;align-items:center;justify-content:center;padding:18px;font-family:var(--body,"Manrope",sans-serif)}
.dy-m.open{display:flex}

/* SCROLL LOCK */
html.dy-lock, body.dy-lock{overflow:hidden !important;overscroll-behavior:none}
body.dy-lock{position:fixed;left:0;right:0;width:100%}
.dy-card, .dy-field{overscroll-behavior:contain}
.dy-m{touch-action:none}

.dy-scrim{position:absolute;inset:0;background:rgba(14,9,4,.72);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}
.dy-card{position:relative;width:min(440px,94vw);background:#170F08;color:#FFF3DC;border:1px solid rgba(255,214,140,.25);
  box-shadow:0 30px 80px -30px rgba(0,0,0,.8),0 0 40px rgba(255,150,50,.12);overflow:hidden}
.dy-x{position:absolute;top:10px;right:10px;z-index:3;width:32px;height:32px;border-radius:50%;border:1px solid rgba(255,214,140,.35);
  background:rgba(0,0,0,.35);color:#FFE6B8;font-size:15px;cursor:pointer}
.dy-x:hover{background:#FFB347;color:#1C1209}
.dy-head{padding:22px 24px 12px;text-align:center}
.dy-eb{font-size:10px;letter-spacing:.24em;text-transform:uppercase;color:#FFB347;font-weight:700}
.dy-h{font-family:var(--display,"Gowun Batang",serif);font-weight:400;font-size:25px;line-height:1.15;margin:8px 0 6px}
.dy-p{font-size:13px;color:rgba(255,243,220,.72);line-height:1.55;max-width:34ch;margin:0 auto}
.dy-hud{display:flex;justify-content:space-between;align-items:center;padding:0 24px 10px;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,243,220,.8)}
.dy-hud b{color:#FFD36E;font-size:15px;letter-spacing:.04em}
.dy-bar{height:3px;margin:0 24px;background:rgba(255,214,140,.15)}
.dy-bar i{display:block;height:100%;width:100%;background:linear-gradient(90deg,#FF7A1A,#FFD36E);transform-origin:0 50%}
.dy-field{position:relative;height:300px;margin-top:12px;overflow:hidden;
  background:radial-gradient(90% 70% at 50% 110%,rgba(255,140,40,.22),transparent 70%)}
@media (pointer: coarse), (max-width: 600px){.dy-m .dy-d{width:34px;height:34px;margin:-17px 0 0 -17px}}
.dy-d{position:absolute;width:44px;height:44px;margin:-22px 0 0 -22px;border:none;background:none;padding:0;cursor:pointer;touch-action:manipulation}
.dy-d svg{width:100%;height:100%;display:block;pointer-events:none}
.dy-d .fl{opacity:0;transform-origin:50% 100%}
.dy-d.lit .fl{opacity:1;animation:dyFl .16s ease-in-out infinite alternate}
.dy-d.lit{pointer-events:none;filter:drop-shadow(0 0 10px rgba(255,170,60,.8))}
.dy-d.bomb.lit{filter:drop-shadow(0 0 12px rgba(255,60,40,.9))}
.dy-d.bomb .pop{color:#FF6B5B}
.dy-field.shake{animation:dyShake .3s}
@keyframes dyShake{25%{transform:translateX(-5px)}75%{transform:translateX(5px)}}
.dy-d .pop{position:absolute;left:50%;top:-6px;transform:translateX(-50%);font-size:12px;font-weight:700;color:#FFD36E;opacity:0}
.dy-d.lit .pop{animation:dyPop .7s ease-out forwards}
@keyframes dyPop{0%{opacity:0;transform:translate(-50%,6px)}30%{opacity:1}100%{opacity:0;transform:translate(-50%,-18px)}}
.dy-start,.dy-cta{display:block;margin:16px auto 22px;background:#FFB347;color:#1C1209;border:none;cursor:pointer;
  font:700 11px/1 var(--body,"Manrope",sans-serif);letter-spacing:.2em;text-transform:uppercase;padding:15px 26px;transition:.2s}
.dy-start:hover,.dy-cta:hover{background:#FFD36E}
.dy-cta[disabled]{opacity:.6;cursor:default}
.dy-win.show{justify-content:space-between;padding:80px 20px 4px}
.dy-over{position:absolute;inset:0;display:none;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:20px;background:rgba(23,15,8,.9)}
.dy-over.show{display:flex}
.dy-msg{font-size:13px;line-height:1.5;color:#FFD36E;min-height:20px;max-width:30ch;margin:0 auto}
.dy-code{display:flex;align-items:center;gap:10px;margin:14px 0 6px;padding:10px 10px 10px 18px;border:1px dashed #FFB347}
.dy-code span{font-size:20px;font-weight:800;letter-spacing:.18em;color:#FFD36E}
.dy-code button{background:#FFB347;color:#1C1209;border:none;cursor:pointer;font:700 10px/1 var(--body,"Manrope",sans-serif);letter-spacing:.16em;text-transform:uppercase;padding:9px 12px}
.dy-small{font-size:11px;color:rgba(255,243,220,.55);letter-spacing:.04em}
.dy-toast{position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;background:#170F08;color:#FFE6B8;border:1px solid rgba(255,214,140,.35);padding:12px 18px;font:600 13px/1.4 var(--body,"Manrope",sans-serif);max-width:90vw;text-align:center;box-shadow:0 10px 30px rgba(0,0,0,.4)}
@media(prefers-reduced-motion:reduce){.dy-d.lit .fl,.dy-egg:hover .fl{animation:none}}
`;
  var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

  function diya(lit) {
    return '<svg viewBox="0 0 40 40" fill="none">' +
      '<path class="fl" d="M20 6c3.6 4.4 4.6 7.6 4.6 10a4.6 4.6 0 1 1-9.2 0c0-2.4 1-5.6 4.6-10z" fill="url(#dyg)"/>' +
      '<defs><radialGradient id="dyg" cx="50%" cy="70%" r="60%"><stop offset="0" stop-color="#FFF6D6"/><stop offset=".55" stop-color="#FFC24A"/><stop offset="1" stop-color="#FF7A1A"/></radialGradient></defs>' +
      '<path d="M20 20.5v2.2" stroke="#2C2217" stroke-width="1.4" stroke-linecap="round"/>' +
      '<path d="M5 23h30c-1.6 7.2-7.6 11-15 11S6.6 30.2 5 23z" fill="#C8552B"/>' +
      '<path d="M5 23h30" stroke="#7A2E14" stroke-width="1.6" stroke-linecap="round"/>' +
      '<path d="M11 27.5c3 1.6 15 1.6 18 0" stroke="#E8B23C" stroke-width="1.2" stroke-linecap="round"/>' +
      '</svg>';
  }

  function cracker() {
    return '<svg viewBox="0 0 40 40" fill="none"><path d="M24 7c3-3 6-2 7 0" stroke="#E8B23C" stroke-width="1.6" stroke-linecap="round"/>' +
      '<circle cx="31.5" cy="6.5" r="2" fill="#FFD36E"/><rect x="11" y="11" width="16" height="23" rx="3" transform="rotate(18 19 22)" fill="#9A2A1E"/>' +
      '<path d="M12 16l15 5M10 22l15 5" stroke="#E8B23C" stroke-width="1.6" transform="rotate(18 19 22)"/></svg>';
  }

  /* ================= STORED WIN (2h) · tamper-evident ================= */

  /* small sync string hash (cyrb53) */
  function hash(s) {
    var h1 = 0xdeadbeef, h2 = 0x41c6ce57;
    for (var i = 0, ch; i < s.length; i++) {
      ch = s.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
  }
  function sign(ts, claimed) { return hash(ts + '|' + (claimed ? 1 : 0) + '|' + SALT); }

  function putWin(ts, claimed) {
    try { localStorage.setItem(WIN_KEY, btoa(ts + '.' + (claimed ? 1 : 0) + '.' + sign(ts, claimed))); } catch (e) {}
  }
  function getWin() {
    try {
      var raw = localStorage.getItem(WIN_KEY);
      if (!raw) return null;
      var p = atob(raw).split('.');
      var ts = parseInt(p[0], 10), claimed = p[1] === '1';
      var bad = !ts || p[2] !== sign(ts, claimed)      /* edited */
             || ts > Date.now() + 60000                /* future timestamp */
             || Date.now() - ts > WIN_TTL;             /* expired */
      if (bad) { localStorage.removeItem(WIN_KEY); return null; }
      return { ts: ts, claimed: claimed };
    } catch (e) {
      try { localStorage.removeItem(WIN_KEY); } catch (_) {}
      return null;
    }
  }
  function saveWin() { putWin(Date.now(), false); }
  function setClaimed(flag) {
    var w = getWin();
    if (w) putWin(w.ts, flag);
  }

  /* "2 hours" / "1 hour 15 min" / "45 min" */
  function timeLeftText(w) {
    var ms = Math.max(0, WIN_TTL - (Date.now() - w.ts));
    var mins = Math.max(1, Math.ceil(ms / 60000));
    if (mins >= 60) {
      var h = Math.floor(mins / 60), r = mins % 60;
      return h + (h > 1 ? ' hours' : ' hour') + (r ? ' ' + r + ' min' : '');
    }
    return mins + ' min';
  }

  /* ================= GIFT ELIGIBILITY (min cart rule) ================= */
  var busy = false;                       /* true while WE are calling cart APIs */
  var nativeFetch = window.fetch.bind(window);
  var CART_RE = /\/cart\/(add|change|update|clear)/;
  var CART_FULL_RE = /\/cart\/(change|update|clear)/;   /* these return the full cart JSON */

  function isGift(item) { return REWARD_IDS.indexOf(item.variant_id) !== -1; }

  /* cart value in paise, EXCLUDING gift lines, AFTER discounts */
  function eligibleTotal(cart) {
    return cart.items.reduce(function (s, i) {
      return isGift(i) ? s : s + (i.final_line_price != null ? i.final_line_price : i.line_price);
    }, 0);
  }
  function needsMore(cart) { return MIN_CART * 100 - eligibleTotal(cart); }  /* paise; <=0 means OK */
  function rupees(p) { return Math.ceil(p / 100); }

  function getCart() {
    return nativeFetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'dy-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.style.display = 'block';
    clearTimeout(toast.t); toast.t = setTimeout(function () { toastEl.style.display = 'none'; }, 4500);
  }

  /* message shown right after a full-page reload (fallback path only) */
  function showRemovedToast() {
    try {
      if (sessionStorage.getItem('dy_removed')) {
        sessionStorage.removeItem('dy_removed');
        toast('Free gift removed. Cart must be \u20B9' + MIN_CART + ' or more.');
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showRemovedToast);
  else showRemovedToast();

  /* reload ONLY the Shopflo iframe(s) so the drawer shows the fresh cart.
     returns how many were refreshed (0 = none found) */
  function refreshShopflo() {
    var n = 0, fs = document.querySelectorAll('iframe');
    for (var i = 0; i < fs.length; i++) {
      var f = fs[i];
      if (/shopflo/i.test((f.src || '') + ' ' + (f.id || '') + ' ' + (f.className || ''))) {
        try { f.src = f.src; n++; } catch (e) {}
      }
    }
    return n;
  }

  function refreshCartUI() {
    if (typeof updateCartCountUI === 'function') { try { updateCartCountUI(); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (/^\/cart\/?$/.test(location.pathname)) location.reload();
  }

  function notifyGift(item, already) {
    var msg = already
      ? '\uD83E\uDE94 Your free gift is already in the cart'
      : '\uD83E\uDE94 Free gift added to your cart!';
    if (typeof showAddToCartPopup === 'function') showAddToCartPopup(item, msg);
    else { toast(msg); refreshCartUI(); }
  }

  /* shuffled copy of the reward ids (Fisher-Yates) */
  function shuffledRewards() {
    var a = REWARD_IDS.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  /* try the random pick first; if it fails (sold out / invalid id),
     fall back to the next one so the shopper still gets a gift */
  function addReward(ids, index) {
    if (index >= ids.length) return Promise.resolve({ ok: false });
    return nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: ids[index], quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (r.ok) return { ok: true, item: d.items ? d.items[0] : d };
        return addReward(ids, index + 1);
      });
    }).catch(function () {
      return addReward(ids, index + 1);
    });
  }

var again = false, hasGift = false, lastReload = 0;

  /* Keeps the cart honest. Optional `hint` = full cart JSON we already have
     (from a /cart/change or /cart/update response) so we skip the extra GET.
     - gift in cart but cart < MIN_CART  -> remove gift instantly (win becomes unclaimed again)
     - gift qty > 1                      -> cap at 1
     - no gift, valid unclaimed win, cart >= MIN_CART -> auto-add gift */
  function enforce(hint) {
    if (busy) { again = true; return Promise.resolve(null); }
    busy = true;
    var known = hint && hint.items ? hint : null;
    return (known ? Promise.resolve(known) : getCart()).then(function (c) {
      var gifts = c.items.filter(isGift);
      hasGift = gifts.length > 0;

      /* ---- auto-add from stored win ---- */
      if (!gifts.length) {
        var w = getWin();
        if (w && !w.claimed && needsMore(c) <= 0) {
          return addReward(shuffledRewards(), 0).then(function (res) {
            if (res.ok && res.item) {
              setClaimed(true); hasGift = true;
              if (m && m.classList.contains('open')) close();
              notifyGift(res.item, false);
            }
            return c;
          });
        }
        return c;
      }

      /* ---- gift already in cart ---- */
      var updates = {}, removed = false, below = needsMore(c) > 0;
      gifts.forEach(function (g) {
        if (below) { updates[g.variant_id] = 0; removed = true; }
        else if (g.quantity > 1) updates[g.variant_id] = 1;
      });
      if (!below) setClaimed(true);               /* gift present + eligible */
      if (!Object.keys(updates).length) return c;
      return nativeFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); }).then(function (nc) {
       if (removed) {
  setClaimed(false);                      /* can be re-added if cart goes back up */
  hasGift = false;
  if (Date.now() - lastReload < 5000) return nc;   /* loop guard */
  lastReload = Date.now();
  try { sessionStorage.setItem('dy_removed', '1'); } catch (e) {}
  location.reload();                      /* clean reload so Shopflo re-initialises */
} else {
  refreshCartUI();
}
        return nc;
      });
    }).catch(function () { return null; })
      .then(function (c) { busy = false; if (again) { again = false; enforce(); } return c; });
  }

  /* watch every cart change (fetch + XHR) — react immediately, reuse response cart */
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(window, arguments);
    if (CART_RE.test(url)) {
      p.then(function (r) {
        if (CART_FULL_RE.test(url)) {
          r.clone().json().then(function (c) { enforce(c); }, function () { enforce(); });
        } else enforce();
      }, function () {});
    }
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (mt, u) { this.__dyUrl = String(u || ''); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var self = this, u = this.__dyUrl || '';
    if (CART_RE.test(u)) {
      this.addEventListener('loadend', function () {
        var c = null;
        if (CART_FULL_RE.test(u)) { try { c = JSON.parse(self.responseText); } catch (e) {} }
        enforce(c);
      });
    }
    return xs.apply(this, arguments);
  };

  /* Shopflo iframe cart changes are invisible to the hooks above:
     react if the iframe posts a message to the page */
  window.addEventListener('message', function (e) {
    if (/shopflo/i.test(e.origin || '')) enforce();
  });

  /* checkout guard: re-check cart before going to checkout */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], button[name="checkout"], a[href^="/checkout"]');
    if (!t || busy) return;
    e.preventDefault(); e.stopPropagation();
    enforce().then(function () { location.href = '/checkout'; });
  }, true);

  /* on page load */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enforce(); });
  else enforce();
  window.addEventListener('pageshow', function (e) { if (e.persisted) enforce(); });

  /* fast watcher: only runs while a gift is in cart OR a win is waiting */
  setInterval(function () {
    if (!document.hidden && !busy && (hasGift || getWin())) enforce();
  }, POLL_MS);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) enforce(); });

  /* ---------- hidden trigger ---------- */
  function placeEgg() {
    var egg = document.createElement('button');
    egg.className = 'dy-egg'; egg.type = 'button';
    egg.setAttribute('aria-label', 'A secret diya. Light it for a Diwali surprise');
    egg.title = 'Psst\u2026 light me';
    egg.innerHTML = diya();
    var h = document.querySelector('.closing-line h2');
    if (h) h.appendChild(egg);
    else { var f = document.querySelector('.foot-bottom') || document.querySelector('footer') || document.body; f.appendChild(egg); }
    egg.addEventListener('click', open);
  }

  /* ---------- modal ---------- */
  var m = document.createElement('div');
  m.className = 'dy-m'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-label', 'Light the Diyas');
  m.innerHTML =
    '<div class="dy-scrim"></div><div class="dy-card">' +
      '<button class="dy-x" type="button" aria-label="Close">\u2715</button>' +
      '<div class="dy-head"><div class="dy-eb">You found a secret</div>' +
        '<div class="dy-h">Light the Diyas</div>' +
        '<p class="dy-p">Light ' + GOAL + ' diyas in ' + TIME + ' seconds, avoid the crackers. Free gift on orders \u20B9' + MIN_CART + '+.</p></div>' +
      '<div class="dy-hud"><span>Lit <b class="dy-n">0</b>/' + GOAL + '</span><span><b class="dy-t">' + TIME + '</b>s</span></div>' +
      '<div class="dy-bar"><i></i></div>' +
      '<div class="dy-field">' +
        '<div class="dy-over show dy-intro"><button class="dy-start" type="button">Start</button></div>' +
        '<div class="dy-over dy-lose"><div class="dy-h" style="font-size:22px">So close!</div><p class="dy-p">The diyas got away this time.</p><button class="dy-start dy-again" type="button">Try again</button></div>' +
        '<div class="dy-over dy-win"><div class="dy-h" style="font-size:30px">You\u2019ve won.</div>' +
          '<p class="dy-msg"></p>' +
          '<button class="dy-cta dy-claim" type="button">Claim Gift</button></div>' +
      '</div></div>';
  document.body.appendChild(m);

  /* SCROLL LOCK: block wheel/touch scrolling on the modal backdrop
     (covers the case where #NavDrawer is itself a scroll container) */
  m.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
  m.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });

  var field = m.querySelector('.dy-field'), nEl = m.querySelector('.dy-n'), tEl = m.querySelector('.dy-t'), bar = m.querySelector('.dy-bar i');
  var intro = m.querySelector('.dy-intro'), lose = m.querySelector('.dy-lose'), win = m.querySelector('.dy-win');
  var msgEl = m.querySelector('.dy-msg');
  var claimBtn = m.querySelector('.dy-claim');
  var raf, spawnT, running = false, lit = 0, t0 = 0, items = [];

  function show(el) { [intro, lose, win].forEach(function (x) { x.classList.toggle('show', x === el); }); }
  function clear() { items.forEach(function (d) { d.el.remove(); }); items = []; }

function spawn(startY) {
  var W = field.clientWidth, H = field.clientHeight;
  var prog = Math.min(1, (performance.now() - t0) / 1000 / TIME);
  var bomb = Math.random() < BOMB_BASE + BOMB + prog * .10;
    var b = document.createElement('button');
    b.className = 'dy-d' + (bomb ? ' bomb' : ''); b.type = 'button'; b.setAttribute('aria-label', bomb ? 'Cracker' : 'Light this diya');
    b.innerHTML = (bomb ? cracker() : diya()) + '<span class="pop">' + (bomb ? '\u22122' : '+1') + '</span>';
    field.insertBefore(b, intro);
    var d = { el: b, x: 24 + Math.random() * (W - 48), y: startY != null ? startY : H + 26, vy: (40 + Math.random() * 25) * SPD * (1 + prog * (TOUCH ? .7 : .3)), sw: Math.random() * 6.28, amp: (6 + Math.random() * 12) * SWAY, lit: false };
    b.addEventListener('click', function () {
      if (!running || d.lit) return;
      d.lit = true; b.classList.add('lit');
      if (bomb) { lit = Math.max(0, lit - 2); field.classList.remove('shake'); void field.offsetWidth; field.classList.add('shake'); }
      else lit++;
      nEl.textContent = lit;
      if (lit >= GOAL) end(true);
    });
    items.push(d);
  }

  function loop(ts) {
    if (!running) return;
    var el = (ts - t0) / 1000, left = Math.max(0, TIME - el);
    tEl.textContent = Math.ceil(left);
    bar.style.transform = 'scaleX(' + (left / TIME) + ')';
    for (var i = items.length - 1; i >= 0; i--) {
      var d = items[i];
      d.y -= d.vy / 60 * (d.lit ? .5 : 1);
      var x = d.x + Math.sin(el * 2.6 + d.sw) * d.amp;
      d.el.style.left = x + 'px'; d.el.style.top = d.y + 'px';
      if (d.y < -40) { d.el.remove(); items.splice(i, 1); }
    }
    if (left <= 0) return end(false);
    raf = requestAnimationFrame(loop);
  }

  function start() {
    clear(); lit = 0; nEl.textContent = 0; tEl.textContent = TIME; bar.style.transform = 'scaleX(1)';
    show(null); running = true; t0 = performance.now();
    var H0 = field.clientHeight; [.85, .6, .35].forEach(function (f) { spawn(H0 * f); });
    spawnT = setInterval(function () { spawn(); }, 360);
    raf = requestAnimationFrame(loop);
  }
  function end(won) {
    running = false; clearInterval(spawnT); cancelAnimationFrame(raf);
    if (won) {
      saveWin();                         /* remember the win for 2 hours */
      showWinState(getWin());
    } else show(lose);
  }

  /* ---------- win panel state ---------- */
  function showWinState(w) {
    claimBtn.disabled = false;
    if (w && w.claimed) {
      msgEl.textContent = 'Your free gift is in your cart.';
      claimBtn.style.display = 'none';
    } else {
      msgEl.textContent = 'Your gift is reserved for ' + (w ? timeLeftText(w) : '2 hours') +
        '. Add \u20B9' + MIN_CART + ' of products to your cart and it gets added automatically.';
      claimBtn.style.display = '';
      claimBtn.textContent = 'Claim Gift';
    }
    show(win);
  }

  /* ---------- SCROLL LOCK (keeps page position, works on iOS) ---------- */
  var scrollY = 0, locked = false;
  function lockScroll() {
    if (locked) return;
    locked = true;
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = -scrollY + 'px';
    document.documentElement.classList.add('dy-lock');
    document.body.classList.add('dy-lock');
  }
  function unlockScroll() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('dy-lock');
    document.body.classList.remove('dy-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function open() {
    m.classList.add('open');
    lockScroll();
    clear();
    var w = getWin();
    if (w) showWinState(w);              /* already won in last 2h -> no replay */
    else show(intro);
  }
  function close() {
    m.classList.remove('open');
    unlockScroll();
    running = false; clearInterval(spawnT); cancelAnimationFrame(raf); clear();
  }

  /* ---------- claim gift: only if cart >= MIN_CART, add ONE random reward ---------- */
  function claimFail() {
    claimBtn.disabled = false;
    claimBtn.textContent = 'Try again';
  }

  claimBtn.addEventListener('click', function () {
    if (busy) return;
    claimBtn.disabled = true;
    claimBtn.textContent = 'Checking\u2026';
    msgEl.textContent = '';
    busy = true;   /* stop the watcher reacting to our own add */

    getCart()
      .then(function (c) {
        /* any of the reward items already in cart -> don't add another */
        var existing = c.items.find(isGift);
        if (existing) return { ok: true, item: existing, already: true };

        /* RULE: cart (without gift) must be >= MIN_CART */
        var short = needsMore(c);
        if (short > 0) return { ok: false, short: short };

        return addReward(shuffledRewards(), 0);
      })
      .then(function (res) {
        busy = false;
        if (res.short) {
          msgEl.textContent = 'Add \u20B9' + rupees(res.short) + ' more to unlock your gift. It will be added automatically.';
          claimBtn.textContent = 'Check again';
          claimBtn.disabled = false;
          return;
        }
        if (!res.ok || !res.item) { claimFail(); return; }
        hasGift = true;
        setClaimed(true);
        claimBtn.textContent = 'Added to cart';

        setTimeout(function () {
          /* close the modal first, otherwise the popup (z-index 9999)
             would hide behind it (z-index 2147483100) */
          close();
          notifyGift(res.item, res.already);
        }, 600);
      })
      .catch(function () { busy = false; claimFail(); });
  });

  m.querySelectorAll('.dy-start').forEach(function (b) { b.addEventListener('click', start); });
  m.querySelector('.dy-x').addEventListener('click', close);
  m.querySelector('.dy-scrim').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('open')) close(); });

  /* hidden diya icon removed: game opens via click on the footer tagline */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#NavDrawer .drawer-footer-brand h2')) open();
  });

  function prepTagline() {
    var h = document.querySelector('#NavDrawer .drawer-footer-brand h2');
    if (!h) return;
    h.setAttribute('role', 'button');
    h.setAttribute('tabindex', '0');
    h.style.cursor = 'pointer';
    h.style.webkitTapHighlightColor = 'transparent';
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepTagline);
  else prepTagline();

  window.wellbiDiyaGame = open;
  if (/[?&]diya=1/.test(location.search)) open();
})();